<template>
    <div v-if="data_is_mobile" class="card">
        <p class="text-center">Keys</p>
        <v-row>
            <v-col cols="4" class="text-right">
                <p><v-icon color="green" medium>mdi-circle</v-icon></p>
                <p><strong> &gt; 61% </strong></p>
            </v-col>
            <v-col cols="4" class="text-center">
                <p><v-icon color="yellow" medium>mdi-circle</v-icon></p>
                <p><strong> 40% - 60% </strong></p>
            </v-col>
            <v-col cols="4" class="text-left">
                <p><v-icon color="red" medium>mdi-circle</v-icon></p>
                <p><strong> 0% - 40% </strong></p>
            </v-col>
        </v-row>
        <div class="card-body">
            <v-tabs
            v-model="data_tabs"
            background-color="green"
            class="elevation-2"
            dark
            show-arrows
            centered
            grow
            prev-icon="mdi-arrow-left-bold-box-outline"
            next-icon="mdi-arrow-right-bold-box-outline"
            >
                <v-tabs-slider></v-tabs-slider>
                <v-tab
                :href="`#review-1-tab`">
                    <!-- ############################################# -->
                    <!-- HEADING FOR preview_1-->
                    <!-- ############################################# -->
                    <div v-if="data_review_1_datetime!=undefined && data_review_1_datetime.length!=0">
                        <strong>Review 1</strong>
                        <!--{{data_review_1_datetime[0]}}/{{data_review_1_datetime[1]}}-->
                    </div>
                    <p v-else><strong>Review 1</strong></p>
                    <!-- ############################################# -->
                </v-tab>
                <v-tab
                :href="`#review-2-tab`">
                    <!-- ############################################# -->
                    <!-- HEADING FOR preview_2-->
                    <!-- ############################################# -->
                    <div v-if="data_review_2_datetime!=undefined && data_review_2_datetime.length!=0">
                        <strong>Review 2</strong>
                        <!--{{data_review_2_datetime[0]}}/{{data_review_2_datetime[1]}}-->
                    </div>
                    <p v-else><strong>Review 2</strong></p>
                    <!-- ############################################# -->
                </v-tab>
                <v-tab
                :href="`#review-3-tab`">
                    <!-- ############################################# -->
                    <!-- HEADING FOR preview_3-->
                    <!-- ############################################# -->
                    <div v-if="data_review_3_datetime!=undefined && data_review_3_datetime.length!=0">
                        <strong>Review 3</strong>
                        <!--{{data_review_3_datetime[0]}}/{{data_review_3_datetime[1]}}-->
                    </div>
                    <p v-else><strong>Review 3</strong></p>
                    <!-- ############################################# -->
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="data_tabs">
                <v-tab-item id="review-1-tab">
                    <v-card flat tile>
                        <v-card-text>
                            <!-- ############################################# -->
                            <!-- SECTION_SCORES for preview_1-->
                            <!-- ############################################# -->
                            <div v-if="data_review_1_required_sections!=undefined">
                                <p 
                                v-for="(qst_section,index) in data_review_1_required_sections" 
                                v-bind:key="index">
                                    <!-- split the 'SECTION.' prefix from the name-->
                                    <span>{{qst_section.info.name.split(".")[1]}}</span>
                                    
                                    <ComponentColorCoderPercentage 
                                    v-bind:prop_value="qst_section.score.percentage_total_of_max" 
                                    v-bind:prop_value_total="qst_section.score.total"/>
                                </p>
                            </div>
                            <div v-if="prop_submission_review_1!=undefined && prop_submission_review_1.length!=0">
                                <strong>Total : </strong>
                                <strong>
                                    <ComponentColorCoderPercentage style="font-style:Bold !important;"
                                    v-bind:prop_value="prop_submission_review_1[0].qsts_total_scores.percentage_total_of_max" 
                                    v-bind:prop_value_total="prop_submission_review_1[0].qsts_total_scores.max_total_score"/>
                                </strong>
                            </div>
                            <!-- ############################################# -->
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item id="review-2-tab">
                    <v-card flat tile>
                        <v-card-text>
                            <!-- ############################################# -->
                            <!-- SECTION_SCORES for preview_2-->
                            <!-- ############################################# -->
                            <div v-if="data_review_2_required_sections!=undefined">
                                <p 
                                v-for="(qst_section,index) in data_review_2_required_sections" 
                                v-bind:key="index">
                                    <!-- split the 'SECTION.' prefix from the name-->
                                    <span>{{qst_section.info.name.split(".")[1]}}</span>
                                    
                                    <ComponentColorCoderPercentage 
                                    v-bind:prop_value="qst_section.score.percentage_total_of_max" 
                                    v-bind:prop_value_total="qst_section.score.total"/>
                                </p>
                            </div>
                            <div v-if="prop_submission_review_2!=undefined && prop_submission_review_2.length!=0">
                                <strong>Total : </strong>
                                <strong>
                                    <ComponentColorCoderPercentage style="font-style:Bold !important;"
                                    v-bind:prop_value="prop_submission_review_2[0].qsts_total_scores.percentage_total_of_max" 
                                    v-bind:prop_value_total="prop_submission_review_2[0].qsts_total_scores.max_total_score"/>
                                </strong>
                            </div>
                            <!-- ############################################# -->
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item id="review-3-tab">
                    <v-card flat tile>
                        <v-card-text>
                            <!-- ############################################# -->
                            <!-- SECTION_SCORES for preview_3-->
                            <!-- ############################################# -->
                            <div v-if="data_review_3_required_sections!=undefined">
                                <p 
                                v-for="(qst_section,index) in data_review_3_required_sections" 
                                v-bind:key="index">
                                    <!-- split the 'SECTION.' prefix from the name-->
                                    <span>{{qst_section.info.name.split(".")[1]}}</span>
                                    
                                    <ComponentColorCoderPercentage 
                                    v-bind:prop_value="qst_section.score.percentage_total_of_max" 
                                    v-bind:prop_value_total="qst_section.score.total"/>
                                </p>
                            </div>
                            <div v-if="prop_submission_review_3!=undefined && prop_submission_review_3.length!=0">
                                <strong>Total : </strong>
                                <strong>
                                    <ComponentColorCoderPercentage style="font-style:Bold !important;"
                                    v-bind:prop_value="prop_submission_review_3[0].qsts_total_scores.percentage_total_of_max" 
                                    v-bind:prop_value_total="prop_submission_review_3[0].qsts_total_scores.max_total_score"/>
                                </strong>
                            </div>
                            <!-- ############################################# -->
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </div>

    <!-- NON-MOBILE -->

    <div v-else class="card">
        <div class="text-center">
            <strong>Keys : </strong>
            <v-icon color="green" medium>mdi-circle</v-icon><strong> &gt; 61% </strong> <span class="text-white">.</span> 
            <v-icon color="yellow" medium>mdi-circle</v-icon><strong> 40% - 60% </strong> <span class="text-white">.</span>
            <v-icon color="red" medium>mdi-circle</v-icon><strong> 0% - 40% </strong>
        </div>
        <div class="card-header text-white text-center app-class-priority-areas-heading">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 text-left">
                    <p><strong>Priority Areas</strong></p>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 text-center">
                    <!-- ############################################# -->
                    <!-- HEADING FOR preview_1-->
                    <!-- ############################################# -->
                    <div v-if="data_review_1_datetime!=undefined && data_review_1_datetime.length!=0">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <p v-on="on"><strong>Review 1</strong></p>
                            </template>
                            <p>
                                {{data_review_1_datetime[0]}}/{{data_review_1_datetime[1]}}
                            </p>
                        </v-tooltip>
                    </div>
                    <p v-else><strong>Review 1</strong></p>
                    <!-- ############################################# -->
                </div>

                <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 text-center">
                    <!-- ############################################# -->
                    <!-- HEADING FOR preview_2-->
                    <!-- ############################################# -->
                    <div v-if="data_review_2_datetime!=undefined && data_review_2_datetime.length!=0">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <p v-on="on"><strong>Review 2</strong></p>
                            </template>
                            <p>
                                {{data_review_2_datetime[0]}}/{{data_review_2_datetime[1]}}
                            </p>
                        </v-tooltip>
                    </div>
                    <p v-else><strong>Review 2</strong></p>
                    <!-- ############################################# -->
                </div>

                <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 text-center">
                    <!-- ############################################# -->
                    <!-- HEADING FOR preview_3-->
                    <!-- ############################################# -->
                    <div v-if="data_review_3_datetime!=undefined && data_review_3_datetime.length!=0">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <p v-on="on"><strong>Review 3</strong></p>
                            </template>
                            <span>
                                <p>
                                    {{data_review_3_datetime[0]}}/{{data_review_3_datetime[1]}}
                                </p>
                            </span>
                        </v-tooltip>
                    </div>
                    <p v-else><strong>Review 3</strong></p>
                    <!-- ############################################# -->
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <!-- ############################################# -->
                <!-- SECTION NAMES using iteration of preview_1-->
                <!-- ############################################# -->
                <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
                    <div v-if="data_review_1_required_sections!=undefined">
                        <div 
                        v-for="(qst_section,index) in data_review_1_required_sections" 
                        v-bind:key="index">
                            <!-- split the 'SECTION.' prefix from the name-->
                            <span>{{qst_section.info.name.split(".")[1]}}</span>
                            <!-- stop divider for last item-->
                            <v-divider v-if="data_review_1_required_sections.length-1!=index"></v-divider>
                        </div>
                    </div>
                </div>
                <!-- ############################################# -->

                <v-divider vertical></v-divider>

                <!-- ############################################# -->
                <!-- SECTION_SCORES for preview_1-->
                <!-- ############################################# -->
                <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                    <div v-if="data_review_1_required_sections!=undefined">
                        <div 
                        v-for="(qst_section,index) in data_review_1_required_sections" 
                        v-bind:key="index">
                            <ComponentColorCoderPercentage 
                            v-bind:prop_value="qst_section.score.percentage_total_of_max" 
                            v-bind:prop_value_total="qst_section.score.total"/>
                            <!-- stop divider for last item-->
                            <v-divider v-if="data_review_1_required_sections.length-1!=index"></v-divider>
                        </div>
                    </div>
                </div>
                <!-- ############################################# -->

                <v-divider vertical></v-divider>

                <!-- ############################################# -->
                <!-- SECTION_SCORES for preview_2-->
                <!-- ############################################# -->
                <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                    <div v-if="data_review_2_required_sections!=undefined">
                        <div 
                        v-for="(qst_section,index) in data_review_2_required_sections" 
                        v-bind:key="index">
                            <ComponentColorCoderPercentage 
                            v-bind:prop_value="qst_section.score.percentage_total_of_max" 
                            v-bind:prop_value_total="qst_section.score.total"/>
                            <!-- stop divider for last item-->
                            <v-divider v-if="data_review_2_required_sections.length-1!=index"></v-divider>
                        </div>
                    </div>
                </div>
                <!-- ############################################# -->

                <v-divider vertical></v-divider>

                <!-- ############################################# -->
                <!-- SECTION_SCORES for preview_3-->
                <!-- ############################################# -->
                <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                    <div v-if="data_review_3_required_sections!=undefined">
                        <div 
                        v-for="(qst_section,index) in data_review_3_required_sections" 
                        v-bind:key="index">
                            <ComponentColorCoderPercentage 
                            v-bind:prop_value="qst_section.score.percentage_total_of_max" 
                            v-bind:prop_value_total="qst_section.score.total"/>
                            <!-- stop divider for last item-->
                            <v-divider v-if="data_review_3_required_sections.length-1!=index"></v-divider>
                        </div>
                    </div>
                </div>
                <!-- ############################################# -->
            </div>
        </div>
        <div class="card-footer">
            <div class="row" style="height:2rem;">
                <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 text-left">
                    <!-- ############################################# -->
                    <!-- TOTAL_SCORE title-->
                    <!-- ############################################# -->
                    <div>
                        <strong>Total Score</strong>
                    </div>
                    <!-- ############################################# -->
                </div>

                <v-divider vertical inset></v-divider>

                <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                    <div v-if="prop_submission_review_1!=undefined && prop_submission_review_1.length!=0">
                        <strong>
                            <ComponentColorCoderPercentage style="font-style:Bold !important;"
                            v-bind:prop_value="prop_submission_review_1[0].qsts_total_scores.percentage_total_of_max" 
                            v-bind:prop_value_total="prop_submission_review_1[0].qsts_total_scores.max_total_score"/>
                        </strong>
                    </div>
                </div>

                <v-divider vertical inset></v-divider>

                <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                    <div v-if="prop_submission_review_2!=undefined && prop_submission_review_2.length!=0">
                        <strong>
                            <ComponentColorCoderPercentage style="font-style:Bold !important;"
                            v-bind:prop_value="prop_submission_review_2[0].qsts_total_scores.percentage_total_of_max" 
                            v-bind:prop_value_total="prop_submission_review_2[0].qsts_total_scores.max_total_score"/>
                        </strong>
                    </div>
                </div>

                <v-divider vertical inset></v-divider>

                <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                    <div v-if="prop_submission_review_3!=undefined && prop_submission_review_3.length!=0">
                        <strong>
                            <ComponentColorCoderPercentage style="font-style:Bold !important;"
                            v-bind:prop_value="prop_submission_review_3[0].qsts_total_scores.percentage_total_of_max" 
                            v-bind:prop_value_total="prop_submission_review_3[0].qsts_total_scores.max_total_score"/>
                        </strong>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//########################################
//IMPORTS libs
//########################################
import {Facade_Mobile_Detect} from '@/libs/facades/facade_helpers.js';

//########################################
//IMPORTS components
//########################################

//GENERIC COMPONENTS
import ComponentColorCoderPercentage from '@/components/ComponentColorCoderPercentage';

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentScoreCard',

    components:{
        ComponentColorCoderPercentage
    },

    props:[
        'prop_submission_review_1',
        'prop_submission_review_2',
        'prop_submission_review_3'
    ],

    data: function()
    {
        return {
            data_tabs:null
        }
    },

    computed:{
        data_is_mobile:function()
        {
            var is_mobile = Facade_Mobile_Detect.check();
            console.log("IS_MOBILE",is_mobile)
            return is_mobile
        },
        data_review_1_datetime:function()
        {
            if(this.prop_submission_review_1 != undefined && this.prop_submission_review_1.length != 0)
            {
                //returns the split datetime as list [0]-date [1]-time
                return this.prop_submission_review_1[0].info.submission_time.split("T");
            }
            else
            {
                return undefined
            }
        },
        data_review_2_datetime:function()
        {
            if(this.prop_submission_review_2 != undefined && this.prop_submission_review_2.length != 0)
            {
                //returns the split datetime as list [0]-date [1]-time
                return this.prop_submission_review_2[0].info.submission_time.split("T");
            }
            else
            {
                return undefined
            }
        },
        data_review_3_datetime:function()
        {
            if(this.prop_submission_review_3 != undefined && this.prop_submission_review_3.length != 0)
            {
                //returns the split datetime as list [0]-date [1]-time
                return this.prop_submission_review_3[0].info.submission_time.split("T");
            }
            else
            {
                return undefined
            }
        },
        data_review_1_required_sections:function()
        {
            if(this.prop_submission_review_1 != undefined && this.prop_submission_review_1.length != 0)
            {
                //not all sections are required for the scorecard
                //so get only required
                return this.prop_submission_review_1[0].qsts_sectioned.filter(
                    function(qst_sec)
                    {
                        if(qst_sec.info.required_for_score)
                        {
                            return true;
                        }
                        else
                        {
                            return false;
                        }
                    }
                )
            }
            else
            {
                return undefined
            }
        },
        data_review_2_required_sections:function()
        {
            if(this.prop_submission_review_2 != undefined && this.prop_submission_review_2.length != 0)
            {
                //not all sections are required for the scorecard
                //so get only required
                return this.prop_submission_review_2[0].qsts_sectioned.filter(
                    function(qst_sec)
                    {
                        if(qst_sec.info.required_for_score)
                        {
                            return true;
                        }
                        else
                        {
                            return false;
                        }
                    }
                )
            }
            else
            {
                return undefined
            }
        },
        data_review_3_required_sections:function()
        {
            if(this.prop_submission_review_3 != undefined && this.prop_submission_review_3.length != 0)
            {
                //not all sections are required for the scorecard
                //so get only required
                return this.prop_submission_review_3[0].qsts_sectioned.filter(
                    function(qst_sec)
                    {
                        if(qst_sec.info.required_for_score)
                        {
                            return true;
                        }
                        else
                        {
                            return false;
                        }
                    }
                )
            }
            else
            {
                return undefined
            }
        },
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
